import request from '@/utils/request'

const base = '/cio/device-exception'
export const pageDeviceException = params => request({ url: `${base}/page`, method: 'get', params })
export const getDeviceException = params => request({ url: `${base}/detail`, method: 'get', params })
export const addDeviceException = data => request({ url: `${base}/add`, method: 'post', data })
export const editDeviceException = data => request({ url: `${base}/edit`, method: 'post', data })
export const deleteDeviceException = data => request({ url: `${base}/delete`, method: 'post', data })
